<template>
    <div class="row">
        <div class="col-lg-6 col-12" v-for="newsItem in news" :key="news.id">
            <div class="card">
                <img class="card-img-top" :src="newsItem.imageSrc" :alt="newsItem.title">
                <div class="card-body">
                    <h5 class="card-title">{{ newsItem.title }}</h5>
                    <p class="card-text">{{ newsItem.caption }}</p>
                    <router-link class="btn btn-purple" :to="newsItem.href">{{ newsItem.buttonTitle }}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'NewsMain',
  data () {
    return {
      msg: '',
      title: 'В связи с 20 летим проекта мы вручили 25 памятных медалей и поговорили с основной группой разработчиков и технологов.',
      news: [
        {
            title: 'Список 25-ти медалистов проекта (2017г.)',
            caption: 'В связи с 20 летим проекта мы вручили 25 памятных медалей и поговорили с основной группой разработчиков и технологов',
            buttonTitle: 'Подробнее',
            href: '/waterman-20',
            imageSrc: '/static/img/waterman20/waterman20-cropped.jpg',
        },

        {
            title: 'Интервью участников проекта (2017г.)',
            caption: 'Как красавицы из ОмскВодоканала и четверо айтишников построили уникальное отраслевое решение для биллинга в ЖКХ',
            buttonTitle: 'Подробнее',
            href: '/interviewWaterman20',
            imageSrc: '/static/img/waterman20/waterman20-composite-2023-ai.jpg'}
      ],
    }
  }
}
</script>

<style scoped>
    .row {
        margin-top: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/parts/NewsMain.vue